"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
exports.__esModule = true;
exports.setInitCalled = exports.initCalled = exports.logEvent = exports.logTypedEvent = void 0;
var frameStart_1 = require("../metadata/frameStart");
var eventMetadata_1 = require("../metadata/eventMetadata");
var event_1 = require("./event");
var logger_1 = require("../logger");
var grapheneMetrics_1 = require("../grapheneMetrics");
var environment_1 = require("../environment");
var debug_1 = require("../debug");
var framesLogQueue_1 = require("./queue/framesLogQueue");
var log = (0, logger_1.getLogger)("logEvent");
var logTypedEvent = function () { return logEvent; };
exports.logTypedEvent = logTypedEvent;
var pendingItems = 0;
function logEvent(event) {
    if (!exports.initCalled) {
        throw new Error("initBlizzard must be called prior to calling logEvent");
    }
    var eventName = (0, event_1.isProtoEventData)(event) ? event.eventName : event.event_name;
    var items = [];
    var clientTs = new Date();
    log.info("Logging event", eventName, event);
    var frameStart = (0, frameStart_1.getFrameStart)();
    items.push(frameStart);
    var metadata = (0, eventMetadata_1.getEventMetadata)(eventName, clientTs);
    var wrappedEvent = {
        eventName: eventName,
        metadata: metadata,
        data: event
    };
    items.push(wrappedEvent);
    (0, debug_1.logDebugAction)({ type: "EventLogged", event: wrappedEvent });
    pendingItems += items.length;
    grapheneMetrics_1.blizzardGraphene.addHistogram({
        metricsName: grapheneMetrics_1.LOG_EVENT_BUFFER_SIZE,
        value: pendingItems
    });
    if (pendingItems > items.length) {
        log.debug("#logEvent: Pending items: ".concat(pendingItems));
    }
    enqueueItems(items);
}
exports.logEvent = logEvent;
function enqueueItems(items) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var resolvedItems, resolvedItems_1, resolvedItems_1_1, item;
        var e_1, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4, Promise.all(items)];
                case 1:
                    resolvedItems = _d.sent();
                    try {
                        for (resolvedItems_1 = __values(resolvedItems), resolvedItems_1_1 = resolvedItems_1.next(); !resolvedItems_1_1.done; resolvedItems_1_1 = resolvedItems_1.next()) {
                            item = resolvedItems_1_1.value;
                            pendingItems--;
                            if (item === null) {
                                continue;
                            }
                            if ((0, frameStart_1.isFrameStart)(item)) {
                                log.info("Enqueuing a new FrameStart", item);
                                (0, debug_1.logDebugAction)({ type: "FrameStartEnqueued", frameStart: item });
                                grapheneMetrics_1.blizzardGraphene.increment({
                                    metricsName: grapheneMetrics_1.LOG_FRAME_START,
                                    dimensions: {
                                        app: (_a = (0, environment_1.getAppEnvironment)().application) !== null && _a !== void 0 ? _a : ""
                                    }
                                });
                            }
                            else if ((0, event_1.isEvent)(item)) {
                                log.debug("Enqueuing an event", item);
                                (0, debug_1.logDebugAction)({ type: "EventEnqueued", event: item });
                                grapheneMetrics_1.blizzardGraphene.increment({
                                    metricsName: grapheneMetrics_1.LOG_EVENT,
                                    dimensions: {
                                        name: item.eventName,
                                        app: (_b = (0, environment_1.getAppEnvironment)().application) !== null && _b !== void 0 ? _b : ""
                                    }
                                });
                            }
                            framesLogQueue_1.framesLogQueue.append(item);
                            log.debug("#enqueueItems: ".concat(pendingItems, " remaining"));
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (resolvedItems_1_1 && !resolvedItems_1_1.done && (_c = resolvedItems_1["return"])) _c.call(resolvedItems_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    return [2];
            }
        });
    });
}
exports.initCalled = false;
function setInitCalled() {
    exports.initCalled = true;
}
exports.setInitCalled = setInitCalled;
//# sourceMappingURL=index.js.map